import { render, staticRenderFns } from "./top-default.vue?vue&type=template&id=add1fafe&"
import script from "./top-default.vue?vue&type=script&lang=ts&"
export * from "./top-default.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {LayoutHeader: require('/var/www/front/components/layout/header.vue').default,LayoutFooter: require('/var/www/front/components/layout/footer.vue').default})
